import './Styles.scss';

const openNav = () => {
    const bodyEle = document.querySelectorAll('body')[0];
    const burgerMenu = document.getElementById('burger-menu');

    const openMenu = 'has-open-navbar';
    
    burgerMenu.addEventListener('click', () => {
        if(!bodyEle.classList.contains(openMenu)) {
            return bodyEle.classList.add(openMenu);
        } else {
            return bodyEle.classList.remove(openMenu);
        }
    })
}

const openDropDown = () => {
    const dropDownTogglers = document.querySelectorAll('.nav-item__dropdown--toggler');

    const openDropDown = 'has-open-dropdown';

    dropDownTogglers.forEach(dropDownToggler => {
        dropDownToggler.addEventListener('click', () => {
            const parent = dropDownToggler.parentElement

            if(!parent.classList.contains(openDropDown)) {
                return parent.classList.add(openDropDown);
            } else {
                return parent.classList.remove(openDropDown)
            }
        })
    })
}

const scrollHandler = () => {
    document.addEventListener('scroll', s => {
        const scrollPos = document.documentElement.scrollTop;
        const nav = document.querySelector('.header-nav');

        if(scrollPos >= 80) {
            nav.classList.add('header-nav--fixed');
        } else if(scrollPos < 80) {
            nav.classList.remove('header-nav--fixed');
        }
    })
}

scrollHandler()
openNav();
openDropDown();

// Search form
const searchForm = () => {
    const searchToggler = document.getElementById('search-toggler')
    const searchForm = document.getElementById('search-form')

    searchForm.addEventListener('click', (event) => {
        event.stopPropagation()
    })

    searchToggler.addEventListener('click', (event) => {
        event.stopPropagation()

        searchForm.classList.toggle('search-form--hidden')
        searchForm.querySelector('.form-control').focus()
    })

    window.addEventListener('click', () => {
        searchForm.classList.add('search-form--hidden')
    })
}

searchForm()